import axios from "axios";
import Vue from "vue";
export default {
  getUser: (state, payload) => {
    if (payload !== null && payload !== undefined && payload !== "") {
      const headers = { token: payload };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/getuserinfo`, {
          headers,
        })
        .then((response) => {
          state["user"] = response.data.data;
          //   this.getPurchasedInfo();
        })
        .catch((error) => {
          if (error.response.status === 403 || error.response.status === 401) {
            Vue.cookie.delete("token");
            window.location.href = process.env.VUE_APP_BASE_URL + "/login";
          }
        });
    }
  },
  getCustomerPlan: (state, payload) => {
    if (payload !== null && payload !== undefined && payload !== "") {
      const headers = { token: payload };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/getCustomerPlan`, {
          headers,
        })
        .then((response) => {
          state["customerPlan"] = response.data.data;
          //   this.getPurchasedInfo();
        })
        .catch((error) => {
          if (error.response.status === 403 || error.response.status === 401) {
            Vue.cookie.delete("token");
            window.location.href = process.env.VUE_APP_BASE_URL + "/login";
          }
        });
    }
  },
  getBalance: (state, payload) => {
    if (payload !== null && payload !== undefined && payload !== "") {
      const headers = { token: payload };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/getCustomerBalance`, {
          headers,
        })
        .then((response) => {
          state["customerBalance"] = response.data.data;
          //   this.getPurchasedInfo();
        })
        .catch((error) => {
          if (error.response.status === 403 || error.response.status === 401) {
            Vue.cookie.delete("token");
            window.location.href = process.env.VUE_APP_BASE_URL + "/login";
          }
        });
    }
  },
  getWalletBalance: (state, payload) => {
    if (payload !== null && payload !== undefined && payload !== "") {
      const headers = { token: payload };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/getWalletBalance`, {
          headers,
        })
        .then((response) => {
          console.log("WALLET BALANCE", response);
          state["walletBalance"] = response.data.data;
          //   this.getPurchasedInfo();
        })
        .catch((error) => {
          if (error.response.status === 403 || error.response.status === 401) {
            Vue.cookie.delete("token");
            window.location.href = process.env.VUE_APP_BASE_URL + "/login";
          }
        });
    }
  },
  setAllPlan: (state) => {
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/getAllPlan`)
      .then((response) => {
        if (response.status == 200) {
          state["allPlan"] = response.data.data;
        }
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) {
          Vue.cookie.delete("token");
          window.location.href = process.env.VUE_APP_BASE_URL + "/login";
        }
      });
  },
  setTablePrice: (state) => {
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/getPlanPrice`)
      .then((response) => {
        if (response.status == 200) {
          state["tablePrice"] = response.data.data;
        }
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) {
          Vue.cookie.delete("token");
          window.location.href = process.env.VUE_APP_BASE_URL + "/login";
        }
      });
  },
  setCustomerPlan: (state, payload) => {
    state["customerPlan"] = payload;
  },
  updateClientKey: (state, payload) => {
    state["clientKey"] = payload;
  },
  updateAudioInfo: (state, payload) => {
    state["audioInfo"] = payload;
  },
  updateFileInfo: (state, payload) => {
    state["fileInfo"] = payload;
  },
  clearUser: (state) => {
    state["user"] = null;
  },
  updatePlaying: (state, payload) => {
    state["playing"] = payload;
  },
  updateAllPlay: (state, payload) => {
    state["allPlay"] = payload;
  },
  updateCurrentAudioId: (state, payload) => {
    state["currentAudioId"] = payload;
  },
  updateSelectedProject: (state, payload) => {
    state["selectedProject"] = payload;
  },
  updateSuccessMessage: (state, payload) => {
    state["snackbars"].success = payload.state;
    state["info"].success = payload.message;
    state.timeout = payload.timeout;
  },
  updateBuySuccessMessage: (state, payload) => {
    state["snackbars"].success = payload.state;
    state["info"].success = payload.message;
    state.timeout = payload.timeout;
  },
  updateErrorMessage: (state, payload) => {
    state["snackbars"].error = payload.state;
    state["info"].error = payload.message;
    state.timeout = payload.timeout;
  },
  updateWarningMessage: (state, payload) => {
    state["snackbars"].warning = payload.state;
    state["info"].warning = payload.message;
    state.timeout = payload.timeout;
  },
  updateSynthesizeState: (state, payload) => {
    state["synth_state"] = payload;
  },
  updateFocusedFileId: (state, payload) => {
    state.focusedFileId = payload;
  },
  updateWarningFileDialog: (state, payload) => {
    state["warningFileDialog"] = payload;
  },
  userLogOut: () => {
    Vue.cookie.delete("token");
    window.location.href = process.env.VUE_APP_BASE_URL + "/login";
  },
};
